/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TB License Platform API
 * Lean v1 controlled-pilot contract. One active Product Key allocates one
 * seat and may authorize at most one active Activation. Product Keys and
 * Activation Secrets are write-only delivery credentials and never appear in
 * admin read responses.
 *
 * OpenAPI spec version: 1.1.0
 */

export type APIActivityFiltersOutcome = typeof APIActivityFiltersOutcome[keyof typeof APIActivityFiltersOutcome];


export const APIActivityFiltersOutcome = {
  committed: 'committed',
  replayed: 'replayed',
  rejected: 'rejected',
  unknown: 'unknown',
  not_applicable: 'not_applicable',
} as const;
